// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TabsList {
  display: flex;
  height: 22px;
  align-items: center;
  gap: 35px;
  margin: var(--spacing_7) 0;
}
.TabsList .tabItem {
  color: #9ba1ad;
  color: var(--color_neutral_500, #9ba1ad);
  font-size: 14px;
  font-weight: 700;
  text-decoration: none;
  border-bottom: 2px solid transparent;
  height: 22px;
  display: block;
  box-sizing: border-box;
}
.TabsList .tabItem::after {
  display: block;
  content: "";
  width: 0;
  transition: width 200ms;
  transition-delay: 200ms;
}
.TabsList .TabItem-blocked-tab {
  display: block;
  height: 22px;
  box-sizing: border-box;
  color: #e1e5ed;
  color: var(--color_neutral_400, #e1e5ed);
  font-size: 14px;
  font-weight: 700;
  cursor: not-allowed;
  white-space: nowrap;
}
.TabsList .activeTabItem {
  color: var(--color_primary_500);
}
.TabsList .activeTabItem::after {
  width: 32px;
  border-bottom: 2px solid var(--color_primary_500);
  padding-top: 2px;
}`, "",{"version":3,"sources":["webpack://./src/components/TabsList/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,SAAA;EACA,0BAAA;AACF;AACE;EACE,cAAA;EAAA,wCAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,oCAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;AACJ;AACI;EACE,cAAA;EACA,WAAA;EACA,QAAA;EACA,uBAAA;EACA,uBAAA;AACN;AAME;EACE,cAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;EAAA,wCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AAJJ;AAOE;EACE,+BAAA;AALJ;AAOI;EACE,WAAA;EACA,iDAAA;EACA,gBAAA;AALN","sourcesContent":[".TabsList {\n  display: flex;\n  height: 22px;\n  align-items: center;\n  gap: 35px;\n  margin: var(--spacing_7) 0;\n\n  .tabItem {\n    color: var(--color_neutral_500, #9ba1ad);\n    font-size: 14px;\n    font-weight: 700;\n    text-decoration: none;\n    border-bottom: 2px solid transparent;\n    height: 22px;\n    display: block;\n    box-sizing: border-box;\n\n    &::after {\n      display: block;\n      content: '';\n      width: 0;\n      transition: width 200ms;\n      transition-delay: 200ms;\n    }\n  }\n\n  // Same shape as .tabItem, dimmed: the lighter tone is what marks the tab as locked, replacing the\n  // lock icon this change removed. It previously styled the tab as an 8px dot, leaving the label to\n  // overflow a round swatch.\n  .TabItem-blocked-tab {\n    display: block;\n    height: 22px;\n    box-sizing: border-box;\n    color: var(--color_neutral_400, #e1e5ed);\n    font-size: 14px;\n    font-weight: 700;\n    cursor: not-allowed;\n    white-space: nowrap;\n  }\n\n  .activeTabItem {\n    color: var(--color_primary_500);\n\n    &::after {\n      width: 32px;\n      border-bottom: 2px solid var(--color_primary_500);\n      padding-top: 2px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
